// Created by 任泽阳. // 基于带图弹窗封装的组件 // *****************************
<template>
  <c-alert
    @close='close'
    :imgMap='imgMap'
    @confirm='confirm'
    :buttonText='buttonText'
    :showFlag='showFlag'
    imageType='1'
    :haveClose="haveClose"
    :title="titleText"
  >
    <section class='verificationc-alert'>
      <!-- <div class='alertTitle b-1-cl'>{{ titleText }}</div> -->
      <div class='alertText'>{{ detaText }}</div>
      <div
        class='alertError gray-10-bd'
        v-for='(item, index) in dataList'
        :key='index'
      >
        <svg-icon :iconClass="item.flag ? 'icon-right-answer' : 'icon-wrong-answer'" className="icon-16"></svg-icon>
        <span class='alertError-text main-cl'>{{ item.text }}</span>
        <!-- <span class='alertError-icon'>
          <svg class='icon icon-14' aria-hidden='true' v-if='item.flag'>
            <use xlink:href='#icon-a_14_1'></use>
          </svg>
          <svg class='icon icon-14' aria-hidden='true' v-else>
            <use xlink:href='#icon-a_14'></use>
          </svg>
        </span> -->
      </div>
    </section>
  </c-alert>
</template>
<script>
export default {
  name: 'c-verifyCationc-alert',
  props: {
    imgMap: {
      type: Object,
      default: () => {},
      required: true,
    },
    // 数据列表
    dataList: {
      type: Array,
      default: () => [],
    },
    titleText: { default: '', type: String },
    detaText: { default: '', type: String },
    // 展示变量
    showFlag: { default: false, type: Boolean },
    // button文案
    buttonText: { default: '', type: String },
    haveClose: { default: true, type: Boolean },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    confirm() {
      this.$emit('confirm');
    },
  },
};
</script>
<style lang='stylus' scoped>
.verificationc-alert {
  .alertTitle {
    margin-bottom: 15px;
  }
  .alertText {
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    padding: 16px 24px 24px;
    box-sizing: border-box;
  }
  .alertError {
    height: 40px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    padding: 10px 24px;
    box-sizing: border-box;
    .alertError-text {
      font-size: 14px;
      line-height: 20px;
      margin-left: 8px;
    }
  }

  .alertBot {
    margin-bottom: 16px;
  }
}
</style>
